import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function data(apiData = [], onEdit) {
  return {
    columns: [
      { Header: "Community Name", accessor: "communityname", align: "left" },
      { Header: "Community Id", accessor: "community_id", align: "left" },
      { Header: "Total Units", accessor: "units", align: "center" },
      { Header: "Sold Units", accessor: "sold", align: "center" },

      { Header: "Action", accessor: "action", align: "center" },
    ],

    rows: apiData.map((item) => ({
      communityname: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.communityname ?? "-"}
        </MDTypography>
      ),
      community_id: (
        <MDTypography variant="caption" color="text">
          {item.community_id ?? "-"}
        </MDTypography>
      ),
      units: (
        <MDTypography variant="caption" color="text">
          {item.units ?? "-"}
        </MDTypography>
      ),
      sold: (
        <MDTypography variant="caption" color="text">
          {item.soldunits ?? "-"}
        </MDTypography>
      ),
      status: (
        <MDTypography variant="caption" color="text">
          {item?.cancel == 0 && item.approve == 0 ? "Pending" : "" ?? "-"}
        </MDTypography>
      ),
      action: (
        <MDTypography
          component="a"
          href="#"
          variant="caption"
          color="info"
          fontWeight="medium"
          onClick={(e) => {
            e.preventDefault();
            onEdit(item);
          }}
        >
          Edit
        </MDTypography>
      ),
    })),
  };
}
